export default __webpack_public_path__ + "static/bubble-with-negative-values-fe68fe502b64a5431a8b9976158dd1d4.png";